import * as React from 'react';
import {FeedItem, Feed} from '../types'
import {FeedListRow} from './FeedListRow'

declare var I18n : {
  locale: string,
  t: (_:string, __?: any) => string,
  toCurrency:(_:number) => string
}

export type FeedListProps = {
  feeds: FeedItem[]
  removeFeed:(_:Feed) => void
  syncFeed:(_:Feed) => void
}

export const FeedList = (props:FeedListProps) => (
  props.feeds.length <= 0 ?
    <div className={"no_result"}>{I18n.t("calendar_feeds.crud.empty")}</div>
  : <table>
      <tbody>
        {props.feeds.map(item => (
          <FeedListRow
            key={`feed${item.feed.id}`}
            item={item}
            onDelete={() => props.removeFeed(item.feed)}
            onSync={() => props.syncFeed(item.feed)}
          />
        ))}
      </tbody>
    </table>
);
